import CitySEOHead from "@/components/feature/CitySEOHead";
import AugustaHeroSection from "./components/HeroSection";
import AugustaStickyNav from "./components/StickyNav";
import AugustaProcessingTimeSection from "./components/ProcessingTimeSection";
import AugustaServicesSection from "./components/ServicesSection";
import AugustaLocalAreaSection from "./components/LocalAreaSection";
import AugustaTestimonialsSection from "./components/TestimonialsSection";
import AugustaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AugustaComparisonSection from "./components/ComparisonSection";
import AugustaMistakesSection from "./components/MistakesSection";
import AugustaHowItWorksSection from "./components/HowItWorksSection";
import AugustaFAQSection, { faqs } from "./components/FAQSection";
import AugustaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AugustaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const augustaFaqs = faqs as { q: string; a: string }[];

const augustaServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function AugustaPage() {
  return (
    <>
      <CitySEOHead
        city="Augusta"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/augusta"
        title="Emergency & Expedited Passport Augusta GA | Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Augusta, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Augusta and the CSRA. Get your emergency passport fast!"
        geoPlacename="Augusta, Georgia"
        geoPosition="33.4734;-82.0105"
        faqs={augustaFaqs}
        servicesSchema={augustaServices}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Augusta passport, same day passport Augusta, fast passport Georgia"
      />
      <div className="font-sans">
        <AugustaHeroSection />
        <AugustaStickyNav />
        <AugustaProcessingTimeSection />
        <AugustaServicesSection />
        <AugustaLocalAreaSection />
        <AugustaTestimonialsSection />
        <AugustaAcceptanceFacilitiesSection />
        <AugustaComparisonSection />
        <AugustaMistakesSection />
        <AugustaHowItWorksSection />
        <AugustaFAQSection />
        <AugustaHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/augusta" state="GA" />
        <AugustaFinalCTA />
      </div>
    </>
  );
}